<div style="margin:0 20px;">
  <nb-card>
    <nb-card-body>
      <app-view *ngIf="create" [info]="create" [items]="create?.data?.content" [data]="create_data"></app-view>
    </nb-card-body>
  </nb-card>
  <button nbButton status="primary" (click)="createData(data.type)" *ngIf="!hasErrors() && !created">Create</button>
</div>
